import { render, staticRenderFns } from "./loginLoading.vue?vue&type=template&id=06f614be&scoped=true&"
import script from "./loginLoading.vue?vue&type=script&lang=js&"
export * from "./loginLoading.vue?vue&type=script&lang=js&"
import style0 from "./loginLoading.vue?vue&type=style&index=0&id=06f614be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f614be",
  null
  
)

export default component.exports